export default "__VITE_ASSET__0327fcec__"